/**
 * Canonical chevron icons for all dropdowns across the design system.
 *
 * These are the single source of truth for chevron styling:
 * - 20×20 viewport, stroke-based, rounded caps
 * - Used by TreeSelect triggers, SelectBox dropdowns, and tree-item toggles
 *
 * For a wrapped toggle button (circular hover area), use `ChevronToggle` instead.
 */

interface ChevronProps {
  className?: string;
  /** Icon size in px. Default: 20 */
  size?: number;
}

export function ChevronDown({ className, size = 20 }: ChevronProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronUp({ className, size = 20 }: ChevronProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M15 12.5L10 7.5L5 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Inline chevron for use inside tree-item rows (expand/collapse toggle).
 * Renders pointing right when collapsed, down when expanded.
 */
export function ChevronRight({ className, size = 20 }: ChevronProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M7.5 5L12.5 10L7.5 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export type { ChevronProps };
